export const emailEW = "support@workl.co"

export const emailEB = "support@workl.co"
